import React, { createContext, useContext, useState } from "react"

const YearContext = createContext()

export const useYear = () => useContext(YearContext)

export const YearProvider = ({ children }) => {
  const [selectedYear, setSelectedYear] = useState("2025")

  return (
    <YearContext.Provider value={{ selectedYear, setSelectedYear }}>
      {children}
    </YearContext.Provider>
  )
}
